import { onMounted, ref } from 'vue';

type Appearance = 'light' | 'dark' | 'system';

export function updateTheme() {
  if (typeof window === 'undefined') {
    return;
  }

  // Force dark mode regardless of user preference
  document.documentElement.classList.add('dark');
}

const setCookie = (name: string, value: string, days = 365) => {
  if (typeof document === 'undefined') {
    return;
  }

  const maxAge = days * 24 * 60 * 60;

  document.cookie = `${name}=${value};path=/;max-age=${maxAge};SameSite=Lax`;
};

export function initializeTheme() {
  if (typeof window === 'undefined') {
    return;
  }

  // Force dark mode regardless of saved preferences
  updateTheme();

  // No need for system theme change listener since we're forcing dark mode
}

const appearance = ref<Appearance>('system');

export function useAppearance() {
  onMounted(() => {
    // Force dark appearance regardless of saved preference
    appearance.value = 'dark';
  });

  function updateAppearance() {
    // Always force dark mode regardless of user selection
    appearance.value = 'dark';

    // Store dark preference in localStorage and cookie
    localStorage.setItem('appearance', 'dark');
    setCookie('appearance', 'dark');

    updateTheme();
  }

  return {
    appearance,
    updateAppearance,
  };
}
